<template>
  <div class="page dashboard-page">
    <div class="box-order-data-overview">
      <el-row :gutter="15" class="wrapper">
        <el-col :lg="8">
          <div class="item section">
            <h5 class="page-title">{{$t('home.dataOverview')}}</h5>
            <el-table :data="dataOverview" :show-header="false">
              <el-table-column
                prop="name"
                label="name"
                class-name="field-column"
              />
              <el-table-column
                prop="value"
                label="value"
                :width="120"
                class-name="price-column"
              />
            </el-table>
          </div>
          <div class="item section" style="margin-top: 13px;">
            <h5 class="page-title">{{$t('home.visitTrend')}}</h5>
            <el-table :data="visitTrend" :show-header="false">
              <el-table-column
                prop="date"
                label="Date"
                class-name="field-column"
              />
              <el-table-column
                prop="pv"
                label="PV"
                :width="120"
                class-name="price-column"
              />
              <el-table-column
                prop="uv"
                label="UV"
                :width="120"
                class-name="price-column"
              />
            </el-table>
          </div>
        </el-col>
        <el-col :lg="8">
          <div class="item section search-record">
            <h5 class="page-title">{{$t('home.top10PostFollowedCount')}}</h5>
            <el-table :data="top10PostFollowedCount" :show-header="false">
              <el-table-column
                prop="name"
                label="name"
                class-name="field-column"
              />
              <el-table-column
                prop="value"
                label="value"
                :width="120"
                class-name="price-column"
              />
            </el-table>
          </div>
        </el-col>
        <el-col :lg="8">
          <div class="item section search-record">
            <h5 class="page-title">{{$t('home.top10ProductFollowedCount')}}</h5>
            <el-table :data="top10ProductFollowedCount" :show-header="false">
              <el-table-column
                prop="name"
                label="name"
                class-name="field-column"
              />
              <el-table-column
                prop="value"
                label="value"
                :width="120"
                class-name="price-column"
              />
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import _ from 'lodash';
import moment from 'moment';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';

@Component({
  components: { ECharts }
})
export default class ApplicationHome extends Vue {

  data = {};

  get visitTrend() {
    return this.data.recent_7_visit_trend || [];
  }

  get dataOverview() {
    const { user_count = 0, today_new_user_count = 0, last_month_new_user_count = 0, last_year_new_user_count = 0 } = this.data;
    return [
      {
        name: this.$t('home.userCount'),
        value: user_count
      },
      {
        name: this.$t('home.todayNewUserCount'),
        value: today_new_user_count
      },
      {
        name: this.$t('home.lastMonthNewUserCount'),
        value: last_month_new_user_count
      },
      {
        name: this.$t('home.lastYearNewUserCount'),
        value: last_year_new_user_count
      }
    ]
  }

  get top10PostFollowedCount() {
    return _.map(this.data.top10_post_followed_count || [], (value, key) => {
      const [title, id] = key.replaceAll(/[()]/g, '').split(',');
      return { name: `${title}-${id}`, value: value }
    });
  }

  get top10ProductFollowedCount() {
    return _.map(this.data.top10_product_followed_count || [], (value, key) => {
      const [title, id] = key.replaceAll(/[()]/g, '').split(',');
      return { name: `${title}-${id}`, value: value }
    });
  }

  async mounted() {
    this.data = await this.$request.get('/dashboard');
  }

  createChartOptions(resouceArr, legendArr, customOptions = {}) {
    const xAxisData = [...new Set(Object.keys(resouceArr[0]).concat(Object.keys(resouceArr[1] || {})))].sort((a, b) => moment(a).diff(moment(b)));
    const getSeriesData = (data) => xAxisData.map(item => data[item] || 0);
    const series = [{
      name: legendArr[0],
      type: 'line',
      smooth: true,
      color: '#dc7272',
      data: getSeriesData(resouceArr[0])
    }]
    if (legendArr[1]) {
      series.push({
        name: legendArr[1],
        type: 'line',
        smooth: true,
        color: '#5d93e4',
        data: getSeriesData(resouceArr[1] || {})
      })
    }
    const options = {
      legend: {
        data: legendArr
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c}'
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: xAxisData.map(key => moment(key).format('MM-DD'))
      },
      yAxis: {
        type: 'value'
      },
      series: series,
    }
    return _.merge({}, options, customOptions);
  }
}
</script>
